import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { SessionService } from '../services/session.service';

export const AuthHeaderInterceptorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const session = inject(SessionService);
  const jwt = session.getToken();
  const normalizedJwt = typeof jwt === 'string' ? jwt.replace(/^(Bearer\s+)+/i, '').trim() : '';

  if(normalizedJwt) {
    req = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${normalizedJwt}`),
    });
  }
  return next(req);
};
